// extracted by mini-css-extract-plugin
export default {"root":"Address_root__THKIw"};